import React from 'react';
import PropTypes from 'prop-types';

import styles from './introductionForTechnology.module.scss';

const IntroductionForTechnologyWithXavier = ({ t }) => {
  return (
    <section className={styles.sectionIntroductionForTechnology}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.videoWrapper}>
            <iframe
              src="https://www.youtube.com/embed/tDwWw7VHR5k"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            />
          </div>
          <div className={styles.leftCol}>
            <div className={styles.grayBloc}>
              <span className={styles.textBlock}>{t('text.xavierTechnologyIntro')}</span>
            </div>
            <p className={styles.underText}>
              Demain TV <span className={styles.yellowText}>I</span>
              Demain la Tech
              <span className={styles.yellowText}>I</span>
              2022
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

IntroductionForTechnologyWithXavier.propTypes = {
  t: PropTypes.func.isRequired,
};

export default IntroductionForTechnologyWithXavier;
